// extracted by mini-css-extract-plugin
module.exports = {"name":"Item_name__1Pjnt","cell":"Item_cell__1cbVp","icon":"Item_icon__SP_yE"};